import React from "react";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import AuthenticationService from "../services/AuthenticationService";

const TableStyle = ({ children }) => {
  const userData = AuthenticationService.getUserData();

  const colors = {
    kerakoll: "#afcdaf",
    knauf: "rgb(204, 229, 255)",
  };

  const THEME = createTheme({
    palette: {},
    overrides: {
      MuiPaper: {
        elevation2: {
          boxShadow: "none",
          backgroundColor: "#f5f5f5",
          "& > div": {
            overflowX: "hidden !important",
          }
        },
      },
      MuiTable: {
        root: {
          padding: "0",
          backgroundColor: "#f5f5f5", // TODO replace with tailwind color
        },
      },
      MuiTableHead: {
        root: {
          backgroundColor: colors[userData.business],
          borderRadius: 0,
          textTransform: "uppercase",
          fontWeight: 700,
          color: "white",
        },
      },
      MuiInputBase: {
        root: {
          border: "2px solid #afcdaf",
          borderRadius: 0,
          padding: "0 5px",
          overflow: "hidden",
          "&&&:before": { borderBottom: "0 !important", content: "none" },
          "&&&:after": { borderBottom: "0 !important", content: "none" },
          "&:focus": { border: "0", outlineOffset: "0", boxShadow: "none" },
        },
        inputTypeSearch: {
          "&:focus": { border: "0", outlineOffset: "0", boxShadow: "none" },
        },
        input: {
          "&:focus": { border: "0", outlineOffset: "0", boxShadow: "none" },
        },
      },
      MuiInputAdornment: {
        root: {
          marginLeft: "4px",
        },
      },
      MuiTableRow: {
        root: {
          border: "none",
        },
      },
      MuiFormControl: {
        root: {
          "&&&:before": { borderBottom: "none" },
          "&&:after": { borderBottom: "none" },
        },
      },
      MuiFormControlLabel: {
        root: {
          "&$root": {
            marginLeft: 6,
          },
        },
      },
      MuiCheckbox: {
        root: {
          marginLeft: 6,
        },
        colorSecondary: {
          color: "#afcdaf",
          "&$checked": {
            color: "#afcdaf",
          },
        },
      },
      MuiTableCell: {
        root: {
          border: "none",
          padding: "1em 1.2em !important",
        },
        head: {
          backgroundColor: "transparent !important",
          border: "none",
          borderRadius: 0,
        },
      },
      MuiTableSortLabel: {
        root: {
          "&:hover": { color: "#f5f5f5" },
        },
        active: {
          color: "#f5f5f5 !important",
        },
        icon: {
          color: "#f5f5f5 !important",
        },
      },
      MuiIconButton: {
        root: {
          padding: "0.1em",
          margin: "0 0.5em",
        },
      },
    },
  });

  return (
    <div className="overflow-hidden">
      <MuiThemeProvider theme={THEME}>{children}</MuiThemeProvider>
    </div>
  );
};

export default TableStyle;
